import { defineStore, storeToRefs } from 'pinia';
import { computed, ref } from 'vue';

import { useAuthStore } from '@/common/stores/auth';
import { useEtsyMarketplaceStore } from '@/common/stores/marketplaces';
import { track } from '@/helpers/analytics/mixpanel';

export const useAbusePreventionStore = defineStore('abusePrevention', () => {
  const authStore = useAuthStore();
  const { user } = storeToRefs(authStore);
  const etsyStore = useEtsyMarketplaceStore();

  const isModalVisible = ref(false);
  const currentTool = ref('keyword-tool');
  const isDismissable = ref(false);
  const isPlansPage = ref(false);

  const isShopConnectionRequired = computed(() => {
    if (user.value?.is_shop_connection_required !== undefined) {
      return Boolean(user.value.is_shop_connection_required);
    }

    const isPakistan = user.value?.ip_country?.toUpperCase() === 'PK';
    const hasConnectedShop = (user.value?.connected_shops ?? 0) > 0 || authStore.hasShopConnected;

    return isPakistan && !hasConnectedShop;
  });

  const openConnectShopModal = (
    tool = 'keyword-tool',
    options?: { dismissable?: boolean; isPlansPage?: boolean },
  ) => {
    currentTool.value = tool;
    const plansTools = ['plans', 'lotti', 'jaysway', 'printify', 'haa'];
    const isPlans = options?.isPlansPage ?? (plansTools.includes(tool) || tool.startsWith('a/'));
    isPlansPage.value = isPlans;
    isDismissable.value = options?.dismissable ?? isPlans;
    isModalVisible.value = true;
  };

  const closeConnectShopModal = () => {
    isModalVisible.value = false;
    isDismissable.value = false;
    isPlansPage.value = false;
  };

  const handleConnectShop = () => {
    let moduleName = 'Keyword Tool';
    if (currentTool.value === 'shop-info') {
      moduleName = 'Shop Info';
    } else if (currentTool.value === 'listing-audit') {
      moduleName = 'Listing Audit';
    } else if (currentTool.value === 'plans' || ['lotti', 'jaysway', 'printify', 'haa'].includes(currentTool.value) || currentTool.value.startsWith('a/')) {
      moduleName = 'Plans';
    }

    track('Connect Shop Clicked', {
      Module: moduleName,
      Source: 'Abuse Prevention Modal',
      'Connection Type': 'Etsy Shop',
      'Erank Version': 3,
    });

    etsyStore.connectShop('etsy', currentTool.value);
  };

  return {
    closeConnectShopModal,
    currentTool,
    handleConnectShop,
    isDismissable,
    isModalVisible,
    isPlansPage,
    isShopConnectionRequired,
    openConnectShopModal,
  };
});
